import React, { useState } from 'react';
import {auth} from '../../app-firebase/firebase';
import userAdmin from '../../images/admin/unauthorized-person.png';
import { TiWarningOutline } from 'react-icons/ti';

function UnloggedAdmin(props) {

   const [email, setEmail] = useState('');
   const [pass, setPass] = useState('');

   return (
      <div className="container">
         <div className="unlogged d-flex flex-column justify-content-center align-items-center">
            <div className="user-admin d-flex justify-content-center align-items-center">
               <img src={userAdmin} alt="User admin" />
            </div>
            <div className="unlogged-form">
               {props.error ? 
                  <div className="error-warn">
                     <p><TiWarningOutline className="error-warn-sign"/> {props.error}</p>
                  </div> :
                  null
               }
               <form className="d-flex flex-column">
                  <input type="input" placeholder="Email" onChange={(e) => setEmail(e.target.value)} value={email}></input>
                  <input type="password" placeholder="Password" onChange={(e) => setPass(e.target.value)} value={pass}></input>
                  <button className="btn btn-primary" onClick={(e) => signIn(e, email, pass, props.setIsLogged, props.setError)}>Sign in</button>
               </form>
            </div>
         </div>
      </div>
   )
}


function signIn(e, email, pass, setIsLogged, setError) {
   e.preventDefault();

   const promise = auth.signInWithEmailAndPassword(email, pass);
   promise.then(() => {
      setIsLogged();
   })
   .catch(err => {
      setError(err.message);
   })
}

export default UnloggedAdmin;
